'use client';
import styles from './style.module.scss';
import Typography from '@/components/shared/typography/typography.component';

import { useTranslation } from '@/hook';
import useAuth from '@/hook/use-auth.hook';
import colors from '@/theme/colors.module.scss';
import Image from 'next/image';
import {
    LogoutBlack,
    ProfileIconBlack,
    BookedCarsIconBlack,
    SellCarIconBlack,
} from '../../../../public/Images';
import AccountGuard from './account-guard.component';
import Link from '@/components/WrappedLink';

export default function UserAccount() {
    const { t, i18n } = useTranslation();
    const { name, phone, userInitials, mobileLogout, openProfileClicked } =
        useAuth();

    return (
        <>
            <AccountGuard>
                <div className={styles.pageWrapper}>
                    <div className={styles.userData}>
                        <div className={styles.userDataContainer}>
                            <div className={styles.userDataTag}>
                                <Typography variant="subtitle1Medium">
                                    {userInitials}
                                </Typography>
                            </div>
                            <div className={styles.userDataContent}>
                                <div>
                                    <Typography
                                        variant="body1SemiBold"
                                        color={colors.gray800}
                                    >
                                        {name}
                                    </Typography>
                                </div>
                                <div>
                                    <Typography
                                        variant="caption"
                                        color={colors.gray700}
                                    >
                                        {phone}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.divider} />

                    <div
                        className={styles.personalInfoCotainer}
                        onClick={() => openProfileClicked()}
                    >
                        <div className={styles.personalInfoLabelContainer}>
                            <Image
                                src={ProfileIconBlack}
                                alt="ProfileIconBlack"
                                width="20"
                                height="20"
                            />
                            <Typography variant="body2Medium">
                                {t('personalInformation')}
                            </Typography>
                        </div>
                    </div>

                    <div className={styles.divider} />
                    <div className={styles.optionsContainer}>
                        <Link
                            href={`/${i18n.language}/account/mybookings`}
                            className={`${styles.optionsLabelContainer} `}
                        >
                            <Image
                                src={BookedCarsIconBlack}
                                alt="BookedCarsIconBlack"
                                width="20"
                                height="20"
                            />
                            <Typography variant="body2Medium">
                                {t('buyCarRequests')}
                            </Typography>
                        </Link>
                        <div
                            // href={`/${i18n.language}/account/myappointments`}
                            className={`${styles.optionsLabelContainer} ${styles.temporarlyDisabled}`}
                        >
                            <Image
                                src={SellCarIconBlack}
                                alt="SellCarIconBlack"
                                width="20"
                                height="20"
                            />
                            <Typography variant="body2Medium">
                                {t('sellCarRequests')}
                            </Typography>
                        </div>
                    </div>

                    <div className={styles.divider} />

                    <div className={styles.logoutContainer}>
                        <div
                            className={styles.logoutLabelContainer}
                            onClick={() => mobileLogout()}
                        >
                            <Image
                                src={LogoutBlack}
                                alt="LogoutBlack"
                                width="20"
                                height="20"
                            />
                            <Typography variant="body2Medium">
                                {t('logout')}
                            </Typography>
                        </div>
                    </div>
                </div>
            </AccountGuard>
        </>
    );
}
